<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: rgb(255, 250, 244)">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h3>CTVET Attendance & Course Tracker</h3>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->

<div class="container">
    
    <div class="user-info">
      <div class="avatar">
        <img [src]="user.avatarUrl" alt="User avatar" />
      </div>
      <p class="member-since">CTVET Accredited {{ user.memberSince | date:'mediumDate' }}</p>
      <button class="share-button">Developed by AUCDT IT</button>
    </div>
    
    <div class="menu-grid" >
      <div *ngFor="let item of menuItems" class="menu-item" [routerLink]="item.route">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.name }}</span>
      </div>
    </div>
    
    <nav class="bottom-nav">
      <button *ngFor="let navItem of navItems" class="nav-item">
        <mat-icon>{{ navItem.icon }}</mat-icon>
        <span>{{ navItem.name }}</span>
      </button>
    </nav>
  </div>


</div>
</div>
</div>
</mat-sidenav-content>
</mat-sidenav-container>






